<template>
    <div>
        <div class="app-body">
            <page-header/>
            <go-back style="padding: 20px" v-if="String($route.query.isShowBack) !== 'false'"/>
            <main class="main-content">
                <el-row type="flex" justify="end" style="margin-top: 30px">
                    <el-button type="primary" plain
                               size="small"
                               icon="el-icon-copy-document"
                               @click.stop="handleCopy"
                               style="min-width: 130px">复制问卷
                    </el-button>
                    <el-button type="primary"
                               size="small"
                               icon="el-icon-share"
                               @click.stop="handlePublish"
                               style="min-width: 200px">{{ isPublish ? "分享" : "发布并分享" }}
                    </el-button>
                </el-row>
                <h1 class="title">{{ view.title }}</h1>
                <span class="welcome">{{ view.welcome }}</span>
                <question-view v-for="(question) in view.questionList"
                               :key="question.Id"
                               :mode="mode || 'do'"
                               :id="question.Id"
                               ref="question-view"
                               :number="question.type === 'textDesc' ? '' : question.No"
                               :question.sync="question"/>
            </main>
        </div>
        <bottom-ground/>
        <publish-questionnaire ref="publish" @confirm="onPublish"/>
        <share ref="share" :query="{
            from: $route.query.from,
            Qid: publishVal.Id,
            isViewResult: publishVal.IsUserDispalyResult
        }" :questionnaire-title="view.title"/>
    </div>

</template>

<script>
import BottomGround from "@/components/bottomnav";
import PageHeader from "@/components/manager/ManageHeader";
import QuestionView from "@/components/questionView";
import { formatQuestionnaire, formatBackQuestionnaire, generateBackstageQuestionnaire } from "@/utils/question-config";
import { getStudentAnswer } from "@/api/new-question-iteration/question-user"
// 分享
import Share from "../create-empty/cpns/share"
// 问卷发布设置
import PublishQuestionnaire from "@/components/publishQuestionnaire";
import { addQuestion, publishQuestionnaire } from "@/api/new-question-iteration/question-library";

export default {
    name: "DoQuestionnaire",
    components: {
        BottomGround,
        PageHeader,
        QuestionView,
        Share,
        PublishQuestionnaire
    },
    data(vm) {
        return {
            view: {},
            publishVal: {},
            isPublish: String(vm.$route.query.isPublish) === "true"
        }
    },
    computed: {
        qid() {
            return this.$route.query.Qid
        },
        mode() {
            return this.$route.query.mode
        },
    },
    created() {
        this.getQuestionnaireDetail()
        this.publishVal.Id = this.$route.query.Qid
    },
    methods: {
        getQuestionnaireDetail() {
            if (this.qid) {
                if (this.userId) {
                    getStudentAnswer(this.qid, this.userId).then(res => {
                        formatBackQuestionnaire(res, (params) => {
                            this.view = params
                            this.tempQuestionList = JSON.parse(JSON.stringify(params.questionList))
                        })
                    })
                } else {
                    formatQuestionnaire(this.qid, (params) => {
                        this.view = params
                        this.tempQuestionList = JSON.parse(JSON.stringify(params.questionList))
                    })
                }
            }
        },
        // 处理提交
        // 发布问卷
        handlePublish() {
            if (this.isPublish) {
                this.$refs.share.open()
            } else {
                this.$refs.publish.open()
            }
        },
        // 发布问卷
        publishQuestion(val, close) {
            this.publishVal = val
            publishQuestionnaire(val).then(res => {
                this.$message.success("发布成功")
                typeof close === "function" && close()
                this.$nextTick(() => {
                    this.$refs.share.open()
                })
                this.isPublish = true
            })
        },
        // 监听发布
        onPublish(val, close) {
            const qid = this.$route.query.Qid
            this.publishQuestion(Object.assign(Object.create(null), val, { Id: qid }), close)
        },
        // 处理复制
        handleCopy() {
            const { welcome, title, questionList } = this.view
            addQuestion(generateBackstageQuestionnaire({
                title: title,
                welcome: welcome,
                questionList
            })).then(res => {
                this.$message.success("复制成功")
                this.$router.replace({
                    name: "CreateEmpty",
                    query: {
                        from: this.$route.query.from,
                        Qid: res,
                    }
                })
            })
        },
    }
}
</script>

<style scoped lang="less">
.main-content {
    background-color: #fff;
    padding: 30px 60px;
    margin-bottom: 30px;

    .title {
        text-align: center;
        margin: 20px 0;
    }

    .welcome {
        font-size: 16px;
        font-weight: 500;
        padding-left: 30px;
    }
}
</style>
